import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { ProfileView } from "../../../../services/ProfileService/types/profileTypes";
import { THEME_COLORS } from "../../utils/profileUtils";

interface HeaderSectionProps {
  profile: ProfileView | undefined;
  userName: string;
  onBack: () => void;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({ profile, userName, onBack }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Tooltip title="Back to Profile Search">
      <IconButton onClick={onBack} sx={{ mr: 1 }}>
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
    <Box>
      <Typography variant="h6" component="h1" sx={{ mb: 0, fontWeight: 600, fontSize: '1.1rem' }}>
        Profile: {userName}
      </Typography>
      <Typography variant="body2" color={THEME_COLORS.text.secondary} sx={{ fontSize: '0.8rem' }}>
        Manage role, center access, and claim permissions
        {profile?.organization && (
          <span> | {profile.organization}</span>
        )}
      </Typography>
    </Box>
  </Box>
);